import ContributorPage from '../page-components/ContributorPage';
import { hydratePageComponent } from './base-script';

hydratePageComponent(ContributorPage);
